import table from "assets/images/chart-images/table.png";

const associateEditors = [
    { id: "TCDLAELS-T96r", name: "simple-bar", chartImage: table, v2: "Column", disabled: false, description: "MEDIAN" },
    { id: "TCDLAELS-T99r", name: "simple-bar", chartImage: table, v2: "Row", disabled: false, description: "MEDIAN" },
];

export default associateEditors;